
interface ApiErrorAlertProps {
  error: Error | unknown;
}

const ApiErrorAlert = ({ error }: ApiErrorAlertProps) => {
  if (!error) return null;

  return (
    <div className="p-4 bg-destructive/10 text-destructive rounded-md">
      <p className="font-semibold">Error fetching ElevenLabs agents</p>
      <p className="text-sm">{error instanceof Error ? error.message : "Unknown error"}</p>
      <p className="text-sm mt-2">Make sure your ElevenLabs API key is properly configured.</p>
    </div>
  );
};

export default ApiErrorAlert;
